<template>
  <div class="cashbox-user">

    <div class="cashbox-user__back">
      <md-button class="cashbox-user__back-btn md-icon-button" @click="closeForm">
        <md-icon>keyboard_arrow_left</md-icon>
        <md-tooltip md-direction="top">{{ i18n.lbl_go_back() }}</md-tooltip>
      </md-button>
    </div>

    <form novalidate @submit.prevent="closeForm">
      <div>
        <md-progress-bar md-mode="indeterminate" v-if="isPending"/>

        <div class="md-title cashbox-user__title">{{ title() }}</div>

        <div>
          <div><b>{{ i18n.lbl_account_info() }}:</b></div>
            <div>
              <span class="span-account-id">{{ i18n.lbl_id() }}</span>
              <span class="span-account-id-value">{{ id }}</span>
            </div>
            <div>
              <span>{{ i18n.lbl_email() }}</span>
              <span>{{ email }}</span>
            </div>
            <div v-if="accountType">
              <span>{{ i18n.lbl_account_type() }}</span>
              <span>{{ accountTypeText() }}</span>
            </div>
            <div v-if="accountStateI">
              <span>{{ i18n.kyc_current_account_state() }}</span>
              <span>{{ accountStateText() }}</span>
            </div>
            <div v-if="accountStateI === REQUEST_STATES.rejected || accountStateI === REQUEST_STATES.permanentlyRejected">
              <span>{{ i18n.lbl_reject_reason() }}</span>
              <span>{{ accountRejectReason }}</span>
            </div>
            <div v-if="accountCreated">
              <span>{{ i18n.lbl_created_at() }}</span>
              <span>{{ normalizeDate(accountCreated) }}</span>
            </div>
            <div v-if="accountUpdated">
              <span>{{ i18n.lbl_updated_at() }}</span>
              <span>{{ normalizeDate(accountUpdated) }}</span>
            </div>

          <template v-if="accountType.int === ACCOUNT_TYPES.general">
            <br/>
            <div><b>{{ i18n.lbl_user_info() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.firstName">
                <span>{{ i18n.lbl_first_name() }}</span>
                <span>{{ kyc.firstName }}</span>
              </li>
              <li v-if="kyc.lastName">
                <span>{{ i18n.lbl_last_name() }}</span>
                <span>{{ kyc.lastName }}</span>
              </li>
              <li v-if="kyc.dateOfBirth">
                <span>{{ i18n.lbl_date_of_birth() }}</span>
                <span>{{ kyc.dateOfBirth }}</span>
              </li>
              <li v-if="kyc.idDocumentType">
                <span>{{ i18n.lbl_document_type() }}</span>
                <span>{{ kyc.idDocumentType }}</span>
              </li>
              <li v-if="kyc.idDocumentNumber">
                <span>{{ i18n.lbl_kyc_id() }}</span>
                <span>{{ kyc.idDocumentNumber }}</span>
              </li>
              <li v-if="kyc.documents && kyc.documents.kyc_id_document && kyc.documents.kyc_id_document.key">
                <div>{{ i18n.kyc_copy_passport() }}:</div>
                <template v-if="!documents || !documents.kyc_id_document">
                  <span>{{ i18n.lbl_loading() }}</span>
                </template>
                <template v-else>
                  <div class="step__row">
                    <file-field class="kyc-form__file-field"
                                id="kyc-document-photo"
                                fileType="image"
                                v-model="documents[documentTypes.kycIdDocument]"
                                :label="i18n.kyc_copy_passport()"
                                :type="documentTypes.kycIdDocument"
                    />
                  </div>
                </template>
              </li>
              <li v-else>
                <span>{{ i18n.kyc_copy_passport() }}</span>
                <span>{{ i18n.kyc_document_not_attached() }}</span>
              </li>
            </ul>
            <br/>
            <div><b>{{ i18n.kyc_residence_address() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.residenceCountry">
                <span>{{ i18n.lbl_country() }}</span>
                <span>{{ kyc.residenceCountry }}</span>
              </li>
              <li v-if="kyc.residenceCity">
                <span>{{ i18n.lbl_city() }}</span>
                <span>{{ kyc.residenceCity }}</span>
              </li>
              <li v-if="kyc.residenceAddress">
                <span>{{ i18n.lbl_street_name() }}</span>
                <span>{{ kyc.residenceAddress }}</span>
              </li>
              <li v-if="kyc.residenceZipCode">
                <span>{{ i18n.lbl_zip_code() }}</span>
                <span>{{ kyc.residenceZipCode }}</span>
              </li>
            </ul>
          </template>
          <template v-else-if="accountType.int === ACCOUNT_TYPES.syndicate">
            <br/>
            <div><b>{{ i18n.kyc_general_company_information() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.companyName">
                <span>{{ i18n.business_dir_company_name() }}</span>
                <span>{{ kyc.companyName }}</span>
              </li>
              <li v-if="kyc.website">
                <span>{{ i18n.kyc_company_website() }}</span>
                <span>{{ kyc.website }}</span>
              </li>
              <li v-if="kyc.industry">
                <span>{{ i18n.kyc_company_industry() }}</span>
                <span>{{ kyc.industry }}</span>
              </li>
              <li v-if="kyc.phoneNumber">
                <span>{{ i18n.kyc_company_phone() }}</span>
                <span>{{ kyc.phoneNumber }}</span>
              </li>
            </ul>
            <br/>
            <div><b>{{ i18n.kyc_company_legal_address() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.country">
                <span>{{ i18n.lbl_country() }}</span>
                <span>{{ kyc.country }}</span>
              </li>
              <li v-if="kyc.city ">
                <span>{{ i18n.lbl_city() }}</span>
                <span>{{ kyc.city  }}</span>
              </li>
              <li v-if="kyc.street">
                <span>{{ i18n.lbl_street_name() }}</span>
                <span>{{ kyc.street}}</span>
              </li>
              <li v-if="kyc.zipСode">
                <span>{{ i18n.lbl_zip_code() }}</span>
                <span>{{ kyc.zipСode }}</span>
              </li>
            </ul>
            <br/>
            <div><b>{{ i18n.kyc_company_directors() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.firstName">
                <span>{{ i18n.lbl_first_name() }}</span>
                <span>{{ kyc.firstName }}</span>
              </li>
              <li v-if="kyc.lastName">
                <span>{{ i18n.lbl_last_name() }}</span>
                <span>{{ kyc.lastName }}</span>
              </li>
              <li v-if="kyc.dateOfBirth">
                <span>{{ i18n.lbl_date_of_birth() }}</span>
                <span>{{ kyc.dateOfBirth }}</span>
              </li>
              <li v-if="kyc.idDocumentType">
                <span>{{ i18n.lbl_document_type() }}</span>
                <span>{{ kyc.idDocumentType }}</span>
              </li>
              <li v-if="kyc.idDocumentNumber">
                <span>{{ i18n.lbl_kyc_id() }}</span>
                <span>{{ kyc.idDocumentNumber }}</span>
              </li>
            </ul>
            <br/>
            <div><b>{{ i18n.kyc_residence_address() }}:</b></div>
            <ul class="key-value-list">
              <li v-if="kyc.residenceCountry">
                <span>{{ i18n.lbl_country() }}</span>
                <span>{{ kyc.residenceCountry }}</span>
              </li>
              <li v-if="kyc.residenceCity">
                <span>{{ i18n.lbl_city() }}</span>
                <span>{{ kyc.residenceCity }}</span>
              </li>
              <li v-if="kyc.residenceAddress">
                <span>{{ i18n.lbl_street_name() }}</span>
                <span>{{ kyc.residenceAddress }}</span>
              </li>
              <li v-if="kyc.residenceZipCode">
                <span>{{ i18n.lbl_zip_code() }}</span>
                <span>{{ kyc.residenceZipCode }}</span>
              </li>
            </ul>
          </template>
        </div>

        <md-dialog-actions>
          <md-button class="btn btn_narrow md-primary" @click="closeForm">
            {{ i18n.lbl_close() }}
          </md-button>
        </md-dialog-actions>
      </div>
    </form>
  </div>
</template>

<script>
  import formMixin from '@com/mixins/form.mixin'
  import { i18n } from '@js/i18n'
  import { formatDate } from '@utils/dates.util'
  import get from 'lodash/get'
  import _cloneDeep from 'lodash/cloneDeep'

  import { KycTemplateParser } from '@vue/app/verification/spec/kyc-template-parser.js'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { reviewableRequestsService } from '@api/reviewable_requests.service'
  import { fileService } from '@api/file.service'
  import { usersService } from '@api/users.service'
  import {
    ACCOUNT_TYPES,
    REQUEST_STATES,
    userTypes,
    documentTypes
  } from '@const'

  export default {
    name: 'cashbox-user',
    mixins: [formMixin],
    props: ['id', 'email'],
    data: _ => ({
      ACCOUNT_TYPES,
      REQUEST_STATES,
      documentTypes,
      kyc: {},
      documents: {},
      blobId: '',
      accountType: {},
      accountStateI: '',
      accountUpdated: '',
      accountCreated: '',
      accountRejectReason: '',
      i18n
    }),
    created () {
      document.addEventListener('keydown', this.onDocumentKeyDown, false)
      this.loadKYC()
    },
    destroyed () {
      document.removeEventListener('keydown', this.onDocumentKeyDown, false)
    },
    methods: {
      title () {
        if (this.accountType.string === userTypes.general) {
          return i18n.kyc_personal_details()
        }
        if (this.accountType.string === userTypes.syndicate) {
          return i18n.kyc_corporate_details()
        }
        return i18n.lbl_kyc()
      },
      accountTypeText () {
        if (this.accountType.string === userTypes.general) return i18n.kyc_general()
        if (this.accountType.string === userTypes.syndicate) return i18n.kyc_corporate()
        return i18n.requiresKYC()
      },
      accountStateText () {
        if (this.accountStateI === REQUEST_STATES.approved) return i18n.lbl_verified()
        if (this.accountStateI === REQUEST_STATES.pending) return i18n.lbl_unverified()
        if (this.accountStateI === REQUEST_STATES.rejected ||
          this.accountStateI === REQUEST_STATES.permanentlyRejected) return i18n.lbl_userBlocked()
        return i18n.requiresKYC()
      },
      normalizeDate (timestamp) {
        return formatDate(timestamp, 'DD MMM YYYY hh:mm:ss')
      },
      closeForm () {
        this.$emit('close-kyc')
      },
      onDocumentKeyDown (event) {
        const keyCode = event.which || event.keyCode
        if (keyCode === 27) { // esc key
          this.closeForm()
        }
      },
      disable () {
        this.isButtonDisabled = true
        this.isPending = true
        EventDispatcher.dispatchShowLoaderEvent()
        return Promise.resolve(true)
      },
      enable () {
        this.isButtonDisabled = false
        this.isPending = false
        EventDispatcher.dispatchHideLoaderEvent()
        return Promise.resolve(true)
      },
      async loadKYC () {
        const record = get(await reviewableRequestsService.loadKycReviewableRequests(this.id), 'records', [])
        if (record && record.length) {
          this.blobId = record[0].details.update_kyc.kyc_data.blob_id
          this.accountType = record[0].details.update_kyc.account_type_to_set
          this.accountStateI = record[0].request_state_i
          this.accountUpdated = record[0].updated_at
          this.accountCreated = record[0].created_at
          this.accountRejectReason = record[0].reject_reason
          if (this.blobId && this.accountType) {
            const kycData = await usersService
              .blobsOf()
              .get(this.blobId)
            if (kycData) {
              this.kyc = KycTemplateParser.fromTemplate(kycData, this.accountType.string)
              if (this.kyc.documents) {
                let documents = _cloneDeep(this.kyc.documents)
                this.checkAndUploadDocuments(documents)
              }
            }
          }
        }
      },
      async checkAndUploadDocuments (docs) {
        if (docs.kyc_id_document &&
          docs.kyc_id_document.type === undefined) {
          docs.kyc_id_document['type'] = documentTypes.kycIdDocument
        }
        await this.uploadDocuments(docs)
      },
      async uploadDocuments (docs) {
        this.disable()
        try {
          Object.values(docs).forEach(doc => {
            this.documents[doc.type] = fileService.uploadSingleDocument(doc)
          })
        } catch (error) {
          this.enable()
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .cashbox-user {
    &__title {
      margin: 12px 0;
    }
  }

  .cashbox-user__actions {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .cashbox-user__btn-close {
    display: block;
    margin-left: 0px;
    margin-right: 1rem;
    max-width: 15rem;
  }

  .span-account-id {
    max-width: 10%;
  }
  .span-account-id-value {
    width: auto
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/cashbox/index/Cashbox.User.vue